"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignalRSignalName = exports.SignalRHubName = exports.SignalRMethodName = void 0;
var SignalRMethodName;
(function (SignalRMethodName) {
    SignalRMethodName["JoinGroup"] = "JoinGroup";
    SignalRMethodName["LeaveGroup"] = "LeaveGroup";
})(SignalRMethodName = exports.SignalRMethodName || (exports.SignalRMethodName = {}));
var SignalRHubName;
(function (SignalRHubName) {
    /** @deprecated Use `CheckoutHub` instead */
    SignalRHubName["Checkout"] = "CheckoutHub";
    /** @deprecated Use `CustomerHub` instead */
    SignalRHubName["Customer"] = "CustomerHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["BackgroundWorkerHub"] = "BackgroundWorkerHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["BroadcastMessageHub"] = "BroadcastMessageHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["CheckHub"] = "CheckHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["CheckoutHub"] = "CheckoutHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["CustomerHub"] = "CustomerHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["IncrementalHub"] = "IncrementalHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["MenuTreeHub"] = "MenuTreeHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["OrderHub"] = "OrderHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["OutletClientHub"] = "OutletClientHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["OutletHub"] = "OutletHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["PaymentTerminalHub"] = "PaymentTerminalHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["PrinterHub"] = "PrinterHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["ProductHub"] = "ProductHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["StarCloudPrintHub"] = "StarCloudPrintHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["StockHub"] = "StockHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["TableHub"] = "TableHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["TicketHub"] = "TicketHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["WayOfPaymentHub"] = "WayOfPaymentHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["AdyenIntegrationHub"] = "AdyenIntegrationHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["LicenseHub"] = "LicenseHub";
    /** @deprecated Use Client Specific hubs instead */
    SignalRHubName["SalesGroupHub"] = "SalesGroupHub";
    // Client specific General hubs
    SignalRHubName["GeneralHubPOS"] = "GeneralHub-POS";
    SignalRHubName["GeneralHubKDS"] = "GeneralHub-KDS";
    SignalRHubName["GeneralHubExpress"] = "GeneralHub-Express";
    SignalRHubName["GeneralHubAOA"] = "GeneralHub-AOA";
    SignalRHubName["GeneralHubAOW"] = "GeneralHub-AOW";
    SignalRHubName["GeneralHubAdmin"] = "GeneralHub-Admin";
    // Client specific Beacon hubs
    SignalRHubName["BeaconHubPOS"] = "BeaconHub-POS";
    SignalRHubName["BeaconHubKDS"] = "BeaconHub-KDS";
    SignalRHubName["BeaconHubExpress"] = "BeaconHub-Express";
    SignalRHubName["BeaconHubAOA"] = "BeaconHub-AOA";
    SignalRHubName["BeaconHubAOW"] = "BeaconHub-AOW";
})(SignalRHubName = exports.SignalRHubName || (exports.SignalRHubName = {}));
var SignalRSignalName;
(function (SignalRSignalName) {
    /** @deprecated Use `CheckoutStatusUpdateEvent` instead */
    SignalRSignalName["CheckoutStatusUpdated"] = "CheckoutStatusUpdateEvent";
    /** @deprecated Use `CheckoutItemStatusUpdatedEvent` instead */
    SignalRSignalName["CheckoutItemStatusUpdated"] = "CheckoutItemStatusUpdatedEvent";
    /** @deprecated Use `CheckoutTicketPreptimeUpdatedTimeEvent` instead */
    SignalRSignalName["CheckoutPrepTimeUpdated"] = "CheckoutTicketPreptimeUpdatedTimeEvent";
    /** @deprecated Use `CustomerAnonymizedEvent` instead */
    SignalRSignalName["CustomerAnonymized"] = "CustomerAnonymizedEvent";
    /** @deprecated Use `PaymentStatusUpdatedEvent` or `PaymentTerminalStatusUpdatedEvent` instead */
    SignalRSignalName["CheckPaymentDisplayStatusUpdatedEvent"] = "CheckPaymentDisplayStatusUpdatedEvent";
    /** @deprecated Use `PaymentStatusUpdatedEvent` or `PaymentTerminalStatusUpdatedEvent` instead */
    SignalRSignalName["PaymentTerminalDisplayStatusUpdatedEvent"] = "PaymentTerminalDisplayStatusUpdatedEvent";
    SignalRSignalName["CheckoutStatusUpdateEvent"] = "CheckoutStatusUpdateEvent";
    SignalRSignalName["CheckoutItemStatusUpdatedEvent"] = "CheckoutItemStatusUpdatedEvent";
    SignalRSignalName["CheckoutTicketPreptimeUpdatedTimeEvent"] = "CheckoutTicketPreptimeUpdatedTimeEvent";
    SignalRSignalName["CheckoutPreOrderMemberStatusUpdateEvent"] = "CheckoutAttendeeConfirmedEvent";
    SignalRSignalName["CheckoutDeliveryStatusUpdatedEvent"] = "CheckoutDeliveryStatusUpdatedEvent";
    SignalRSignalName["CustomerAnonymizedEvent"] = "CustomerAnonymizedEvent";
    // License
    SignalRSignalName["LicenseStatusUpdatedEvent"] = "LicenseStatusUpdatedEvent";
    SignalRSignalName["BackgroundWorkerStatusEvent"] = "BackgroundWorkerStatusEvent";
    SignalRSignalName["BroadcastMessagePublishedEvent"] = "BroadcastMessagePublishedEvent";
    SignalRSignalName["CheckCreatedEvent"] = "CheckCreatedEvent";
    SignalRSignalName["CheckDeletedEvent"] = "CheckDeletedEvent";
    SignalRSignalName["CheckMovedEvent"] = "CheckMovedEvent";
    SignalRSignalName["CheckPaidEvent"] = "CheckPaidEvent";
    SignalRSignalName["CheckPaymentStatusUpdated"] = "CheckPaymentStatusUpdated";
    SignalRSignalName["CheckUpdatedCustomNameEvent"] = "CheckUpdatedCustomNameEvent";
    SignalRSignalName["CheckUpdatedEvent"] = "CheckUpdatedEvent";
    SignalRSignalName["CheckMetadataUpdatedEvent"] = "CheckMetadataUpdatedEvent";
    SignalRSignalName["CheckUpdatedOrderFormatEvent"] = "CheckUpdatedOrderFormatEvent";
    SignalRSignalName["CheckPreparingTerminalPaymentEvent"] = "CheckPreparingTerminalPayment";
    SignalRSignalName["CourseForwardedEvent"] = "CourseForwardedEvent";
    SignalRSignalName["IncrementalUnpredictedDirectEvent"] = "IncrementalUnpredictedDirectEvent";
    SignalRSignalName["MenuTreeItemUpdatedEvent"] = "MenuTreeItemUpdatedEvent";
    SignalRSignalName["MenuTreeUpdatedEvent"] = "MenuTreeUpdatedEvent";
    SignalRSignalName["OrderPaymentStatusUpdatedEvent"] = "OrderPaymentStatusUpdatedEvent";
    SignalRSignalName["OrderRefundStatusUpdateEvent"] = "OrderRefundStatusUpdateEvent";
    SignalRSignalName["OutletClientTriggerDiscoveryEvent"] = "OutletClientTriggerDiscoveryEvent";
    SignalRSignalName["OutletClientUnlinkedEvent"] = "OutletClientUnlinkedEvent";
    SignalRSignalName["PaymentTerminalStatusUpdatedEvent"] = "PaymentTerminalStatusUpdatedEvent";
    SignalRSignalName["PosUpdatedEvent"] = "PosUpdatedEvent";
    SignalRSignalName["PrinterCreatedEvent"] = "PrinterCreatedEvent";
    SignalRSignalName["PrinterStatusChanged"] = "PrinterStatusChanged";
    SignalRSignalName["PrinterUpdatedEvent"] = "PrinterUpdatedEvent";
    SignalRSignalName["ProductCreatedEvent"] = "ProductCreatedEvent";
    SignalRSignalName["ProductDeletedEvent"] = "ProductDeletedEvent";
    SignalRSignalName["ProductUpdatedEvent"] = "ProductUpdatedEvent";
    SignalRSignalName["StockProductsCreatedEvent"] = "StockProductsCreatedEvent";
    SignalRSignalName["StockProductsDeletedEvent"] = "StockProductsDeletedEvent";
    SignalRSignalName["StockProductsUpdatedEvent"] = "StockProductsUpdatedEvent";
    SignalRSignalName["SubTicketPrintEvent"] = "SubTicketPrintEvent";
    SignalRSignalName["SubTicketStatusEvent"] = "SubTicketStatusEvent";
    SignalRSignalName["TableCreatedEvent"] = "TableCreatedEvent";
    SignalRSignalName["TableDeletedEvent"] = "TableDeletedEvent";
    SignalRSignalName["TableUpdatedEvent"] = "TableUpdatedEvent";
    SignalRSignalName["TicketStatusEvent"] = "TicketStatusEvent";
    SignalRSignalName["TicketUpdatedTimeEvent"] = "TicketUpdatedTimeEvent";
    SignalRSignalName["WayOfPaymentCreatedEvent"] = "WayOfPaymentCreatedEvent";
    SignalRSignalName["WayOfPaymentDeletedEvent"] = "WayOfPaymentDeletedEvent";
    SignalRSignalName["WayOfPaymentUpdatedEvent"] = "WayOfPaymentUpdatedEvent";
    SignalRSignalName["ExpressUpdatedEvent"] = "ExpressUpdatedEvent";
    SignalRSignalName["TicketItemStatusEvent"] = "TicketItemStatusEvent";
    SignalRSignalName["OrderTicketStatusUpdatedEvent"] = "OrderTicketStatusUpdatedEvent";
    SignalRSignalName["OrderTicketItemStatusUpdatedEvent"] = "OrderTicketItemStatusUpdatedEvent";
    SignalRSignalName["SubTicketStatusUpdateEvent"] = "SubTicketStatusUpdateEvent";
    SignalRSignalName["GuestKdsTicketStatusUpdateEvent"] = "GuestKdsTicketStatusUpdateEvent";
    SignalRSignalName["KdsUpdatedEvent"] = "KdsUpdatedEvent";
    SignalRSignalName["OutletSettingsUpdatedEvent"] = "OutletSettingsUpdatedEvent";
    SignalRSignalName["StammyQRUserAttachedEvent"] = "StammyQRUserAttachedEvent";
    SignalRSignalName["PaymentStatusUpdatedEvent"] = "PaymentStatusUpdatedEvent";
    SignalRSignalName["AdyenIntegrationTerminalDiagnosisEvent"] = "AdyenIntegrationTerminalDiagnosisEvent";
    SignalRSignalName["SaleGroupUpdatedEvent"] = "GroupUpdatedEvent";
    SignalRSignalName["PosNotificationEvent"] = "PosNotificationEvent";
})(SignalRSignalName = exports.SignalRSignalName || (exports.SignalRSignalName = {}));
